import {VoicemailTemplateVariable} from "@/helpers/voicemail_template_helpers";

export const PROVIDER_KNOWN_VARIABLES = [
  VoicemailTemplateVariable.PATIENT_FIRST_NAME,
  VoicemailTemplateVariable.CALLER_NAME,
  VoicemailTemplateVariable.PROVIDER_NAME,
  VoicemailTemplateVariable.CALLBACK_NUMBER,
];

export const FALLBACK_VARIABLES = [
  VoicemailTemplateVariable.PATIENT_FIRST_NAME,
  VoicemailTemplateVariable.CALLER_NAME,
  VoicemailTemplateVariable.PRACTICE_NAME,
  VoicemailTemplateVariable.CALLBACK_NUMBER,
];

export const PREVIEW_SAMPLE = {
  [VoicemailTemplateVariable.PATIENT_FIRST_NAME]: 'Jane',
  [VoicemailTemplateVariable.CALLER_NAME]: 'Laura',
  [VoicemailTemplateVariable.PRACTICE_NAME]: 'Tufts',
  [VoicemailTemplateVariable.PROVIDER_NAME]: 'Patel',
  [VoicemailTemplateVariable.CALLBACK_NUMBER]: '617-209-2376'
};

export const INITIAL_PROVIDER_KNOWN_PLACEHOLDER =
  'Hi {patient_first_name}, this is {caller_name} calling on behalf of {provider_name}. ' +
  'Please call us back at {callback_number}.';

export const INITIAL_FALLBACK_PLACEHOLDER =
  'Hi {patient_first_name}, this is {caller_name} calling from {practice_name}. ' +
  'Please call us back at {callback_number}.';

export const FOLLOW_UP_PROVIDER_KNOWN_PLACEHOLDER =
  'Hi {patient_first_name}, {caller_name} again following up for {provider_name}. ' +
  'You can reach us at {callback_number}.';

export const FOLLOW_UP_FALLBACK_PLACEHOLDER =
  'Hi {patient_first_name}, {caller_name} again from {practice_name}. ' +
  'You can reach us at {callback_number}.';
